import { Controller } from '@hotwired/stimulus'
import { GoogleCharts } from 'google-charts'

// Connects to data-controller="geo-chart"
export default class extends Controller {
  static targets = ['map']
  static values = { data: Array, options: Object }

  connect() {
    this.chart = null
    this.resizeObserver = null
  }

  mapTargetConnected() {
    GoogleCharts.load(this.drawChart.bind(this), { packages: ['geochart'] })
  }

  drawChart() {
    this.chartData = GoogleCharts.api.visualization.arrayToDataTable(
      this.dataValue,
      false,
    )
    this.chart = new GoogleCharts.api.visualization.GeoChart(this.mapTarget)
    this.draw()
    this.resizeObserver = new ResizeObserver(() => this.draw())
    this.resizeObserver.observe(this.mapTarget)
  }

  draw() {
    if (!this.chart || !this.chartData) return

    this.chart.draw(this.chartData, this.optionsValue)
  }

  disconnect() {
    this.resizeObserver?.disconnect()
  }
}
